import { Directive, HostBinding, HostListener, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Directive({
  selector: '[kbRouterOrExternalLink]',
  standalone: true,
})
export class RouterOrExternalLinkDirective implements OnChanges {

  @Input() public safeProtocols = ['callto'];

  @Input() public kbRouterOrExternalLink?: string | null;
  @HostBinding('attr.href') private href?: string | null | SafeUrl = null;

  private urlSchemeRegex = new RegExp('^[a-z0-9]+:', 'i');

  public constructor(
    private router: Router,
    private domSanitizer: DomSanitizer,
  ) {}

  public ngOnChanges(): void {
    if (this.kbRouterOrExternalLink) {
      const safeProtocol = this.safeProtocols.find((value) => this.kbRouterOrExternalLink?.startsWith(`${value}:`));
      this.href = safeProtocol ? this.domSanitizer.bypassSecurityTrustUrl(this.kbRouterOrExternalLink) : this.kbRouterOrExternalLink;
    } else {
      this.href = null;
    }
  }

  @HostListener('click', ['$event.button', '$event.ctrlKey', '$event.metaKey', '$event.shiftKey', '$event.target'])
  public onClick(button: number, ctrlKey: boolean, metaKey: boolean, shiftKey: boolean, targetElement: Element): boolean {
    // prevent elements like svg <use> to trigger navigation
    if (targetElement.tagName !== 'A') {
      return true;
    }

    const href = targetElement.getAttribute('href');
    if (href === null || href === undefined) {
      return true;
    }

    // Do not invoke router on right click, ctrl, meta or shift click
    if (button !== 0 || ctrlKey || metaKey || shiftKey) {
      return true;
    }

    const target = targetElement.getAttribute('target');
    // Do not invoke router if the target is anything except _self
    if (target && target !== '_self') {
      return true;
    }

    // Do not invoke the router if the url is scheme relative
    if (href.startsWith('//')) {
      return true;
    }

    // Do not invoke the router if the url has a scheme
    if (this.urlSchemeRegex.test(href)) {
      return true;
    }

    // At this point the url is guaranteed to point to this application

    // Invoke the angular router
    this.router.navigateByUrl(href);

    // Prevent normal browser navigation
    return false;
  }

}
